// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"b2b84535","205":"6e292d30","266":"8b021fc7","465":"714617eb","484":"ed9bafcb","522":"ce215eb0","551":"a3fb61a5","572":"fa076a43","631":"2c080ee3","737":"ef947cd5","869":"e4be231c","974":"82d07549"}[chunkId] + ".chunk.js";
};